import { IdLabelPair } from '@/models/IdLabelPair.ts';

/**
 * Creates a reduced version of an array of objects with an 'id' property as its key
 */
export const byIdToRecord = <T extends { id: string }>(items: T[]): Record<string, T> => {
    const result: Record<string, T> = {};
    for (const item of items) {
        result[item.id] = item;
    }
    return result;
};

export const byIdToMap = <T extends { id: string }>(items: T[]): Map<string, T> => {
    const map = new Map<string, T>();
    for (const item of items) {
        map.set(item.id, item);
    }
    return map;
};

export const removeDuplicateIds = <T extends IdLabelPair>(arr: T[]): T[] => {
    const seen = new Set();
    return arr.filter((item) => {
        if (seen.has(item.id)) return false;
        seen.add(item.id);
        return true;
    });
};
